componentRegistryInstance.register('color', 'edit', 'hrd.components.form.ColorComponent');
componentRegistryInstance.register('color', 'read', 'hrd.components.form.ColorComponent');

hrd.components.form.ColorComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.ColorComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceEditField: function(field, id, klass) {
		this._super(field, id, klass);
		let config = field.data('config') || {};
		config = $.isPlainObject(config) ? config : $.evaluate(config);
		config = $.extend({}, {
			palette: 'html',
			swatchesWidth: 84,
			swatchesHeight: 256,
			swatchWidth: 11,
			swatchHeight: 11
		}, config)

		if(field.usingChromaFlow() && !$(field).parents('.color-wrapper').exists()) {
			$(field).wrap('<div class="color-wrapper color-container field-container"></div>');
		}

		const $wrapper = $(field).parent('.color-wrapper');

		field.colorpicker({
			regional: hrd.xlate.language,
			colorFormat: '#HEX',
			parts: ['map', 'bar', 'swatches', 'hex', 'rgb', 'preview', 'footer'],
			layout: {
				bar:		[2, 0, 1, 3],
				map:		[3, 0, 1, 3],
				swatches:   [0, 0, 1, 3],
				preview:    [1, 0, 1, 1],
				rgb:        [1, 1, 1, 1],
				hex:        [1, 2, 1, 1]
			},
			swatches: config.palette,
			swatchesWidth: config.swatchesWidth,
			swatchesHeight: config.swatchesHeight,
			swatchWidth: config.swatchWidth,
			swatchHeight: config.swatchHeight,
			altField: field,
			altOnChange: false,
			close: (evt, opt) => {
				if(field.usingChromaFlow()) {
					$wrapper.prop('style').setProperty('--color', opt.formatted);
				} else {
					field.css({
						'background-color': opt.formatted,
						'color': $.colorHelper().computeTextColor(opt.formatted)
					});
				}
			},
			select: (evt, opt) => {
				if(field.usingChromaFlow()) {
					$wrapper.prop('style').setProperty('--color', opt.formatted);
				} else {
					field.val(opt.formatted).css({
						'background-color': opt.formatted,
						'color': $.colorHelper().computeTextColor(opt.formatted)
					});
				}
			}
		});
	},
	enhanceReadField: function(field, id, klass) {
		this._super(field, id, klass);
		switch(field.data('shape')){
			case 'circle':
				field.css({
					'border-radius': '100%',
					'width': '20px',
					'min-width': '20px',
					'max-width': '20px',
					'height': '20px',
					'min-height': '20px',
					'max-height': '20px',
					'padding': '0',
					'align-self': 'center',
				});
				break;
			case 'box-with-text':
				field.css({
					'height': '24px',
					'padding': '0',
					'display': 'flex',
					'justify-content': 'center',
					'align-items': 'center'
				});
				field.parent().css({
					'display': 'flex',
					'justify-content': 'center',
					'align-items': 'center'
				});
				break;
			default:
				break;
		}
	},
	
	setEditableField: function(field, value, object, options) {
		if(field.usingChromaFlow() && !$(field).parent('.color-wrapper').exists()) {
			$(field).wrap('<div class="color-wrapper"></div>')
		}

		const $wrapper = $(field).parent('.color-wrapper');

		if(field.usingChromaFlow() && $wrapper.exists()) {
			$(field).val(value);
			$wrapper.prop('style').setProperty('--color', value || 'transparent');
		} else {
			var colorToApply = value || "#FFFFFF";
			field.val(value);
			field.css({
				'background-color': colorToApply,
				'color': $.colorHelper().computeTextColor(colorToApply)
			});
		}
	},
	setReadOnlyField: function(field, value, object, options) {
		if(value != undefined){
			field.css('border-color', $.colorHelper().darken(value, 15));
			field.css('background-color', tinycolor(value).toRgbString()); // need to pass to rgb otherwise alpha channel will not be added
			field.css('color', $.colorHelper().computeTextColor(value));
		}
	},
	resetEditableField: function(field, options) {
		field.val('');
		field.css({
			'color': '',
			'background-color': ''
		});

		if(field.usingChromaFlow()) {
			const $wrapper = $(field).parent('.color-wrapper');

			if($wrapper.exists()) {
				$wrapper.prop('style').setProperty('--color', 'transparent');
			}
		}
	},
	resetReadOnlyField: function(field, options) {
		if(field.data('shape') !== 'box-with-text'){
			field.text('');
		}

		if(field.usingChromaFlow()) {
			const $wrapper = $(field).parent('.color-wrapper');

			if($wrapper.exists()) {
				$wrapper.prop('style').setProperty('--color', 'transparent');
			}
		}
	}
});